import type { RouteResources } from '@atlassian/react-resource-router';
/* eslint-disable import/order */
import { MenuIdAddons } from '@jira/navigation-apps__constants/src/MenuIdAddons.tsx';
import { SidebarIdGlobalAppsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalAppsSettings.tsx';
import { getNavigationSidebarGlobalSettingsResources } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LegacyPage } from '@jira/router-routes__common/src/ui/legacy-page/main.tsx';
import { manageAppsRoute } from '@jira/router-routes__legacy-global-settings-apps-routes/src/manageAppsRoute.tsx';

export const manageAppsRouteEntry: JiraLegacyRoute<RouteResources> = createLegacyEntry(
	manageAppsRoute,
	() => ({
		canTransitionIn: () => false,
		// eslint-disable-next-line no-restricted-syntax
		component: LegacyPage,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalAppsSettings,
			menuId: MenuIdAddons,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			...getNavigationSidebarGlobalSettingsResources(),
		],
	}),
);
